import * as accountFacadeImpl from "./accountFacadeImpl";
import * as activitiApprovalFacadeImpl from "./activitiApprovalFacadeImpl";
import * as amazonDateRangeRules from "./amazonDateRangeRules";
import * as amazonDateRangeRulesFacadeImpl from "./amazonDateRangeRulesFacadeImpl";
import * as appAccount from "./appAccount";
import * as approvalFlow from "./approvalFlow";
import * as associatedFilesFacadeImpl from "./associatedFilesFacadeImpl";
import * as authorizationRecord from "./authorizationRecord";
import * as authorizationRecordFacadeImpl from "./authorizationRecordFacadeImpl";
import * as bankInfo from "./bankInfo";
import * as bankInfoFacadeImpl from "./bankInfoFacadeImpl";
import * as baseArea from "./baseArea";
import * as baseCity from "./baseCity";
import * as baseCountry from "./baseCountry";
import * as baseDictionary from "./baseDictionary";
import * as baseDictionaryFacadeImpl from "./baseDictionaryFacadeImpl";
import * as baseState from "./baseState";
import * as baseUnit from "./baseUnit";
import * as baseUnitType from "./baseUnitType";
import * as buSbu from "./buSbu";
import * as businessCustomer from "./businessCustomer";
import * as businessCustomerFacadeImpl from "./businessCustomerFacadeImpl";
import * as centerCountyMapping from "./centerCountyMapping";
import * as certBattery from "./certBattery";
import * as certFile from "./certFile";
import * as certMain from "./certMain";
import * as certMainSku from "./certMainSku";
import * as certificationDocument from "./certificationDocument";
import * as cityFacadeImpl from "./cityFacadeImpl";
import * as common from "./common";
import * as corpsInfo from "./corpsInfo";
import * as corpsInfoFacadeImpl from "./corpsInfoFacadeImpl";
import * as costCenter from "./costCenter";
import * as costCenterFacadeImpl from "./costCenterFacadeImpl";
import * as costItemMapping from "./costItemMapping";
import * as costItemMappingFacadeimpl from "./costItemMappingFacadeimpl";
import * as customsInfo from "./customsInfo";
import * as ebsExchangeRate from "./ebsExchangeRate";
import * as ebsResult from "./ebsResult";
import * as exchangeRateFacadeImpl from "./exchangeRateFacadeImpl";
import * as financeAccount from "./financeAccount";
import * as freshdeskDataReportManage from "./freshdeskDataReportManage";
import * as holidayManagement from "./holidayManagement";
import * as holidayManagementFacadeImpl from "./holidayManagementFacadeImpl";
import * as labelDepartmentInfo from "./labelDepartmentInfo";
import * as labelInfo from "./labelInfo";
import * as labelInfoFacadeImpl from "./labelInfoFacadeImpl";
import * as listingQuote from "./listingQuote";
import * as listingQuoteFacadeImpl from "./listingQuoteFacadeImpl";
import * as logisticsAttr from "./logisticsAttr";
import * as logisticsAttrType from "./logisticsAttrType";
import * as logisticsGroup from "./logisticsGroup";
import * as logisticsGroupAttr from "./logisticsGroupAttr";
import * as logisticsGroupFacadeImpl from "./logisticsGroupFacadeImpl";
import * as orderCompany from "./orderCompany";
import * as orderCompanyFacadeImpl from "./orderCompanyFacadeImpl";
import * as pdaVersion from "./pdaVersion";
import * as platform from "./platform";
import * as platformFacadeImpl from "./platformFacadeImpl";
import * as platformShop from "./platformShop";
import * as platformSite from "./platformSite";
import * as platformSiteFacadeImpl from "./platformSiteFacadeImpl";
import * as platformSiteShop from "./platformSiteShop";
import * as platformSiteShopFacadeImpl from "./platformSiteShopFacadeImpl";
import * as platformSiteShopRelevance from "./platformSiteShopRelevance";
import * as plmMaterialCategory from "./plmMaterialCategory";
import * as plmProductBom from "./plmProductBom";
import * as plmProductBomOutgoing from "./plmProductBomOutgoing";
import * as plmProductBomOutgoingItem from "./plmProductBomOutgoingItem";
import * as plmProductCategory from "./plmProductCategory";
import * as plmProductNewOrder from "./plmProductNewOrder";
import * as plmProductSku from "./plmProductSku";
import * as plmProductSpu from "./plmProductSpu";
import * as productBom from "./productBom";
import * as productBrand from "./productBrand";
import * as productCategroy from "./productCategroy";
import * as productConfirm from "./productConfirm";
import * as productMaster from "./productMaster";
import * as productMaterial from "./productMaterial";
import * as productOrder from "./productOrder";
import * as productOrderDemandDetail from "./productOrderDemandDetail";
import * as productOrderUpdateStatusFacadeImpl from "./productOrderUpdateStatusFacadeImpl";
import * as productSku from "./productSku";
import * as productType from "./productType";
import * as revenueDepartment from "./revenueDepartment";
import * as revenueDepartmentFacadeImpl from "./revenueDepartmentFacadeImpl";
import * as rpcBrand from "./rpcBrand";
import * as rpcBusbu from "./rpcBusbu";
import * as rpcCentercounty from "./rpcCentercounty";
import * as rpcCino from "./rpcCino";
import * as rpcCountry from "./rpcCountry";
import * as rpcCurrency from "./rpcCurrency";
import * as rpcPlmCategroy from "./rpcPlmCategroy";
import * as rpcPlmSku from "./rpcPlmSku";
import * as rpcPlmSpu from "./rpcPlmSpu";
import * as rpcProductcategroy from "./rpcProductcategroy";
import * as rpcSku from "./rpcSku";
import * as rpcSpu from "./rpcSpu";
import * as salesChannel from "./salesChannel";
import * as salesChannelFacadeImpl from "./salesChannelFacadeImpl";
import * as staffPaymentInfo from "./staffPaymentInfo";
import * as staffPaymentInfoFacadeImpl from "./staffPaymentInfoFacadeImpl";
import * as stateFacadeImpl from "./stateFacadeImpl";
import * as sysGlobalParam from "./sysGlobalParam";
import * as sysGlobalParamFacadeImpl from "./sysGlobalParamFacadeImpl";
import * as taskApi from "./taskApi";
import * as timelinessDashboard from "./timelinessDashboard";
import * as timelinessDashboardFacadeImpl from "./timelinessDashboardFacadeImpl";
import * as timelinessDashboardMonitor from "./timelinessDashboardMonitor";
import * as timelinessDashboardWarnRecord from "./timelinessDashboardWarnRecord";
import * as timelinessSetting from "./timelinessSetting";

export const basics = {
  accountFacadeImpl,
  activitiApprovalFacadeImpl,
  amazonDateRangeRules,
  amazonDateRangeRulesFacadeImpl,
  appAccount,
  approvalFlow,
  associatedFilesFacadeImpl,
  authorizationRecord,
  authorizationRecordFacadeImpl,
  bankInfo,
  bankInfoFacadeImpl,
  baseArea,
  baseCity,
  baseCountry,
  baseDictionary,
  baseDictionaryFacadeImpl,
  baseState,
  baseUnit,
  baseUnitType,
  buSbu,
  businessCustomer,
  businessCustomerFacadeImpl,
  centerCountyMapping,
  certBattery,
  certFile,
  certMain,
  certMainSku,
  certificationDocument,
  cityFacadeImpl,
  common,
  corpsInfo,
  corpsInfoFacadeImpl,
  costCenter,
  costCenterFacadeImpl,
  costItemMapping,
  costItemMappingFacadeimpl,
  customsInfo,
  ebsExchangeRate,
  ebsResult,
  exchangeRateFacadeImpl,
  financeAccount,
  freshdeskDataReportManage,
  holidayManagement,
  holidayManagementFacadeImpl,
  labelDepartmentInfo,
  labelInfo,
  labelInfoFacadeImpl,
  listingQuote,
  listingQuoteFacadeImpl,
  logisticsAttr,
  logisticsAttrType,
  logisticsGroup,
  logisticsGroupAttr,
  logisticsGroupFacadeImpl,
  orderCompany,
  orderCompanyFacadeImpl,
  pdaVersion,
  platform,
  platformFacadeImpl,
  platformShop,
  platformSite,
  platformSiteFacadeImpl,
  platformSiteShop,
  platformSiteShopFacadeImpl,
  platformSiteShopRelevance,
  plmMaterialCategory,
  plmProductBom,
  plmProductBomOutgoing,
  plmProductBomOutgoingItem,
  plmProductCategory,
  plmProductNewOrder,
  plmProductSku,
  plmProductSpu,
  productBom,
  productBrand,
  productCategroy,
  productConfirm,
  productMaster,
  productMaterial,
  productOrder,
  productOrderDemandDetail,
  productOrderUpdateStatusFacadeImpl,
  productSku,
  productType,
  revenueDepartment,
  revenueDepartmentFacadeImpl,
  rpcBrand,
  rpcBusbu,
  rpcCentercounty,
  rpcCino,
  rpcCountry,
  rpcCurrency,
  rpcPlmCategroy,
  rpcPlmSku,
  rpcPlmSpu,
  rpcProductcategroy,
  rpcSku,
  rpcSpu,
  salesChannel,
  salesChannelFacadeImpl,
  staffPaymentInfo,
  staffPaymentInfoFacadeImpl,
  stateFacadeImpl,
  sysGlobalParam,
  sysGlobalParamFacadeImpl,
  taskApi,
  timelinessDashboard,
  timelinessDashboardFacadeImpl,
  timelinessDashboardMonitor,
  timelinessDashboardWarnRecord,
  timelinessSetting,
};
